import { $, checkEmptyValue, extractValues, convertMaskedDate, differenceInYears } from "./utils";
import moment from "moment";
const identifierName = "data-identifier";
const trimPattern = /^\s+|\s+$/g;
const emojiPattern = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff]|[\ufe00-\ufe0f])/g;

/**
 * verifica se o input é válido
 * @param {Object} event
 */
export const checkValidityError = event => {
	const element = event.target;

	//input vai passar na validação

	if (element.type.match(/radio|checkbox/i) !== null) {
		validateRadioAndCheckboxes(element);
	} else {
		validateTextBoxesSelects(element);
	}
};

/**
 * verifica se o input HTML é válido
 * @param {HTMLElement} element
 */
export const checkValidityErrorHTML = element => {
	let obj = {
		target: element
	};
	checkValidityError(obj);
};

/**
 * Binda validadores ao formulário selecionado
 * @param $form
 */
export const observeValidators = $form => {
	if (!$form) {
		return;
	}

	if ($form.getAttribute("validation-set") == null) {
		$form.setAttribute("validation-set", "");
		extractValues($form.querySelectorAll("*:required")).map(domItem => {
			domItem.onblur = event => {
				event.target.setAttribute("data-touched", "");
				checkValidityError(event);
			};
		});
	}
};

/**
 * Valida caixas de textos, inputs e selects no método
 * @param element
 */
const validateTextBoxesSelects = element => {
	const checkIsValid = item => item !== undefined && item !== null;
	const trimmedValue = element.value.replace(trimPattern, "");
	const pattern = checkIsValid(element.pattern) ? new RegExp(element.pattern) : "";
	const isRequired = element.required;
	let isValid = true;
	let matchPattern = true;
	let isEmpty = false;
	let cpfInvalid = false;
	let phoneInvalid = false;
	let dateInvalid = false;

	const hasBusinessError = element => {
		return !!element.getAttribute("hasBusinessError");
	};

	if (trimmedValue == "" && trimmedValue.match("") !== null && isRequired) {
		//  setAsInvalid(element);
		element.removeAttribute("validationMessage");
		isValid = false;
		isEmpty = true;
	}

	if (
		trimmedValue &&
		trimmedValue.replace(trimPattern).match(pattern) !== null &&
		!hasBusinessError(element)
	) {
		//   setAsValid(element);
		isValid = true;
	}

	if (trimmedValue.replace(trimPattern).match(pattern) == null && isRequired) {
		//   setAsInvalid(element);
		element.removeAttribute("validationMessage");
		isValid = false;
		matchPattern = false;
	}

	if (trimmedValue.match(emojiPattern) !== null) {
		isValid = false;
	}

	if (customValidation(element) === "cpf" && trimmedValue) {
		isValid = validateCPF(element.value);
		element.removeAttribute("validationMessage");
		isValid ? (cpfInvalid = false) : (cpfInvalid = true);
	}

	if (customValidation(element) === "phone" && trimmedValue) {
		isValid = validatePhone(element.value);
		element.removeAttribute("validationMessage");
		isValid ? (phoneInvalid = false) : (phoneInvalid = true);
	}

	if (customValidation(element) === "date" && trimmedValue) {
		isValid ? (dateInvalid = false) : (dateInvalid = true);
	}

	if (hasBusinessError(element) && trimmedValue !== "") {
		isValid = false;
	}

	if (isValid) {
		setAsValid(element);
	} else {
		let message;

		if (element.getAttribute("validationMessage")) {
			message = element.getAttribute("validationMessage");
		} else {
			if (isEmpty) {
				message = "Campo obrigatório";
			} else if (!matchPattern && checkEmptyValue(customValidation(element))) {
				message = "Campo inválido";
			} else if (cpfInvalid) {
				message = "CPF inválido ou inexistente";
			} else if (phoneInvalid) {
				message = "Telefone inválido";
			} else if (dateInvalid) {
				message = "Data deve ser no formato dd/mm/aaaa";
			}
		}
		setAsInvalid(element, message);
	}
};

const customValidation = element => {
	if (element.pattern == "\\d{3}\\.\\d{3}\\.\\d{3}-\\d{2}") {
		return "cpf";
	}

	if (element.pattern == "\\d{2}\\/\\d{2}\\/\\d{4}") {
		return "date";
	}

	if (element.name.search("phone") >= 0) {
		return "phone";
	}

	if (element.name.search("terms") >= 0) {
		return "terms";
	}
};

/**
 * Valida radios e checkboxes no método checkValidityError
 * @param element
 */
const validateRadioAndCheckboxes = element => {
	let isChecked = $(`input[name=${element.name}]:checked`) !== null;
	let isValid = false;
	let checkboxTermsInvalid = false;

	if (isChecked) {
		isValid = true;
	}

	if (customValidation(element) === "terms") {
		isValid ? (checkboxTermsInvalid = false) : (checkboxTermsInvalid = true);
	}

	if (isValid) {
		setAsValid(element);
	} else {
		let message;

		if (checkboxTermsInvalid) {
			message = "Você deve aceitar os Termos e Condições para prosseguir";
		}

		setAsInvalid(element, message);
	}
};

/**
 * Muda aspecto do input para inválido
 * @param {Object} element
 * @param {String} message
 */
export const setAsInvalid = (element, message) => {
	const addErrorClass = (item, message) => {
		item.classList.add("has-error");
		item.setAttribute("data-tooltip", message);
		item.setAttribute("data-flow", "down");
	};

	const invalidMessage = checkEmptyValue(message) ? "Campo obrigatório" : message;

	try {
		const formGroupWrapper = $(`[${identifierName}=${element.name}]`);
		element.setAttribute("data-touched", "");

		if (formGroupWrapper !== null && formGroupWrapper.constructor !== Array) {
			[formGroupWrapper].map(formGroup => {
				addErrorClass(formGroup, invalidMessage);
			});
		}

		if (formGroupWrapper !== null && formGroupWrapper.constructor === Array) {
			formGroupWrapper.map(formGroup => {
				addErrorClass(formGroup, invalidMessage);
			});
		}
	} catch (e) {
		console.log("erro ao capturar elemento - ", e);
		console.log("erro ao capturar elemento NAME ", element.name);
	}
};

/**
 * Muda o aspecto do input para válido
 * @param {Object} element
 */
export const setAsValid = element => {
	element.removeAttribute("invalid");

	const removeErrorClass = item => {
		item.classList.remove("has-error");
		item.removeAttribute("data-tooltip");
		item.removeAttribute("data-flow");
	};

	const formGroupWrapper = $(`[${identifierName}=${element.name}]`);

	if (formGroupWrapper !== null && formGroupWrapper.constructor !== Array) {
		[formGroupWrapper].map(removeErrorClass);
	}

	if (formGroupWrapper !== null && formGroupWrapper.constructor === Array) {
		formGroupWrapper.map(removeErrorClass);
	}
};

/**
 * Válida CPF
 * @param {String} strCPF
 */
export const validateCPF = strCPF => {
	strCPF = strCPF.replace(/[^\d]/g, "");

	let soma;
	let resto;
	soma = 0;

	if (
		strCPF === "00000000000" ||
		strCPF === "11111111111" ||
		strCPF === "22222222222" ||
		strCPF === "33333333333" ||
		strCPF === "44444444444" ||
		strCPF === "55555555555" ||
		strCPF === "66666666666" ||
		strCPF === "77777777777" ||
		strCPF === "88888888888" ||
		strCPF === "99999999999"
	) {
		return false;
	}

	for (let i = 1; i <= 9; i++) soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
	resto = (soma * 10) % 11;

	if (resto == 10 || resto == 11) resto = 0;
	if (resto != parseInt(strCPF.substring(9, 10))) return false;

	soma = 0;
	for (let i = 1; i <= 10; i++) soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
	resto = (soma * 10) % 11;

	if (resto == 10 || resto == 11) resto = 0;
	if (resto != parseInt(strCPF.substring(10, 11))) return false;

	return true;
};

/**
 * Válida telefone para legth
 * @param {String} phone
 */
export const validatePhone = phone => {
	const isValidDDD = phone => {
		return /^(1[1-9]|2[12478]|3[1-578]|4[1-9]|5[13-5]|6[1-9]|7[13-579]|8[1-9]|9[1-9])/.test(phone);
	};

	const cleanPhone = String(phone).replace(/\D/g, "");

	if (isValidDDD(cleanPhone)) {
		return cleanPhone.slice(2).length === 8 || cleanPhone.slice(2).length === 9;
	}

	return false;
};

/**
 * Valida cartão de crédito por bandeira e com Lun Algorithm
 * @param {String} cardNumber
 * @param {String} brand
 */
export const validateCreditCard = (cardNumber, brand) => {
	let isValid = false,
		brandsRegex,
		cardNumbersOnly = cardNumber.replace(/\D/g, ""),
		cardNumberLength = cardNumbersOnly.length;

	switch (brand) {
		case "visa":
		case "cartao_visa":
			brandsRegex = /^4(\d{12}|\d{15})$/;
			break;
		case "master":
		case "mastercard":
		case "cartao_master":
			brandsRegex = /^5[0-9]\d{14}$/;
			break;
		case "amex":
		case "cartao_amex":
		case "american_express":
			brandsRegex = /^3(3|7)\d{13}$/;
			break;
		case "diners":
		case "dinners":
		case "cartao_diners":
			brandsRegex = /^3((6|8)\d{12}|(00|01|02|03|04|05)\d{11})$/;
			break;
		case "elo":
		case "cartao_elo":
			brandsRegex = /^(((431274)|(506717)|(506718)|(506733)|(506739)|(506774)|(506776)|(506778)|(509013)|(509033)|(509064)|(636297)|(401178)|(401179)|(438935)|(457393)|(457631)|(457632)|(504175)|(506720)|(506721)|(506740)|(506753)|(506775)|(506777)|(509072)|(509074)|(509076)|(636368)|(506707)|(506708)|(506715)|(506719)|(509012)|(509032)|(509034)|(509070)|(509071)|(509075)|(509084)|(?:50908[5-9]|50909[0-9]|509[1-7][0-9][0-9]|50980[0-9]|509810)|(?:65090[1-9]|65091[0-9]|650920)|(?:65048[5-9]|65049[0-9]|6505[0-2][0-9]|65053[0-8])|(?:65054[1-9]|6505[5-8][0-9]|65059[0-8])|(?:65070[0-9]|65071[0-8])|(?:65072[0-7])|(?:65165[2-9]|6516[6-7][0-9])|(?:65500[0-9]|65501[0-9])|(?:65502[1-9]|6550[3-4][0-9]|65505[0-8])|(?:65040[5-9]|6504[1-3][0-9])|(?:50674[1-3])|(?:50900[4-9])|(?:50902[0-9]|50903[0-1])|(?:50903[5-9]|50904[0-9]|50905[0-3])|(?:50907[7-9]|509080)|(?:50672[4-9]|50673[0-2])|(?:50674[4-8])|(?:50900[0-2])|(?:50906[6-9])|(?:50908[1-3])|(?:50675[0-2])|(?:50901[4-9])|(?:50905[4-9]|50906[0-3]))\d{0,10})$/;
			break;
		case "hipercard":
		case "cartao_hipercard":
			if (cardNumberLength === 16) {
				brandsRegex = /^606282\d{10}$/;
			} else {
				brandsRegex = /^3841[046]0\d{13}$/;
			}
			break;
		case "aura":
		case "cartao_aura":
			brandsRegex = /^50\d{17}$/;
			break;
	}

	if (brandsRegex.test(cardNumbersOnly)) {
		isValid = true;
	}

	// Se for HIPERCARD com valor antigo não valida na rotina abaixo
	if ((brand === "hipercard" || brand === "cartao_hipercard") && cardNumberLength === 19) {
		return isValid;
	}

	if (isValid) {
		isValid = luhnAlgorithm(cardNumbersOnly);
	}

	return isValid;
};

/**
 * Valida sobrenome para sufixos
 * @param {String} nameToCheck
 */
export const verifyPassengerSuffixName = nameToCheck => {
	const suffixNames = [
		"filho",
		"filha",
		"jr",
		"junior",
		"júnior",
		"neto",
		"neta",
		"sobrinho",
		"sobrinha"
	];

	let tempLastname = nameToCheck.toLowerCase();
	tempLastname = tempLastname.trim();
	tempLastname = tempLastname.split(" ");

	return !(tempLastname.length === 1 && suffixNames.indexOf(tempLastname[0]) > -1);
};

/**
 * Valida idade de passageiros por tipo - adults, children, infants
 * @param {String} type
 * @param {String} dateEntered - formato de entrada DD/MM/YYYY
 * @param {String} outboundDate - formato de entrada YYYY/MM/DD
 */
export const verifyPassengerBirthday = (type, dateEntered, outboundDate) => {
	const dateFormat = "DD/MM/YYYY";
	let dateFlight = outboundDate;
	let dateInput = convertMaskedDate(dateEntered);
	const isValidDate = moment(dateEntered, dateFormat, true).isValid();

	if (checkEmptyValue(dateInput)) {
		return {
			isValid: false,
			msg: "Data de nascimento vazia"
		};
	}

	if (!isValidDate) {
		return {
			isValid: false,
			msg: "Data de nascimento deve ser no formato dd/mm/aaaa"
		};
	}

	const day = dateInput.substring(8, 10),
		month = dateInput.substring(5, 7),
		year = dateInput.substring(0, 4),
		dayF = dateFlight.substring(8, 10),
		monthF = dateFlight.substring(5, 7),
		yearF = dateFlight.substring(0, 4),
		age11 = 12,
		age2 = 2,
		currdate = new Date(),
		birthday = new Date(),
		flightday11 = new Date(),
		flightday2 = new Date();

	if (differenceInYears(dateEntered) > 120) {
		return {
			isValid: false,
			msg: "Você deve ter menos de 120 anos de idade."
		};
	}

	switch (type) {
		case "adults":
			birthday.setFullYear(year, month - 1, day);
			currdate.setFullYear(currdate.getFullYear() - age11);
			flightday11.setFullYear(yearF - age11, monthF - 1, dayF);

			return {
				isValid: currdate - birthday > 0 || birthday <= flightday11,
				msg: "Você deve ter mais de 12 anos de idade."
			};

		case "children":
			birthday.setFullYear(year, month - 1, day);
			flightday11.setFullYear(yearF - age11, monthF - 1, dayF);

			if (flightday11 - birthday >= 0) {
				return {
					isValid: false,
					msg: "Idade incompatível para criança."
				};
			}

			flightday2.setFullYear(yearF - age2, monthF - 1, dayF);

			return {
				isValid: flightday2 - birthday >= 0,
				msg: "Idade incompatível para criança."
			};

		case "infants":
			birthday.setFullYear(year, month - 1, day);
			flightday2.setFullYear(yearF - age2, monthF - 1, dayF);
			let monthsDiff = moment(dateFlight).diff(moment(birthday), "months");

			return {
				isValid: monthsDiff <= 23 && monthsDiff >= 0 && moment(birthday) <= moment(new Date()),
				msg: "Idade incompatível para bebê."
			};
	}
};

/**
 * Valida vencimento do passaporte para com a data do vôo
 * @param {String} dateEntered - formato de entrada DD/MM/YYYY
 * @param {String} outboundDate - formato de entrada YYYY/MM/DD
 */
export const verifyPassengerPassportExpiration = (dateEntered, outboundDate) => {
	const dateFormat = "DD/MM/YYYY";
	const dateInput = moment(convertMaskedDate(dateEntered));
	const dateFlight = moment(outboundDate);
	const today = moment();
	const isValidDate = moment(dateEntered, dateFormat, true).isValid();
	const isExpired = today > dateInput;
	const isExpiredOnFlightday = dateFlight > dateInput;

	if (dateEntered.length < 10) {
		return {
			isValid: false,
			msg: "Passaporte incompleto"
		};
	}

	if (!isValidDate) {
		return {
			isValid: false,
			msg: "Data de validação deve ser no formato dd/mm/aaaa"
		};
	}

	if (isExpired || isExpiredOnFlightday) {
		return {
			isValid: false,
			msg: "Passaporte inválido para esse vôo"
		};
	}

	return { isValid: true };
};

/**
 * Valida string pra ver se existem 2 palavras
 * @param {String} str
 */
export const validateStringTwoWords = str => {
	const values = str.split(" ").filter(function(v) {
		return v !== "";
	});
	return values.length > 1;
};

/**
 * Valida data para o formato DD/MM/YYYY
 * @param {String} dateEntered
 */
export const validateBRDate = dateEntered => {
	const birthDate = moment(dateEntered, "DD/MM/YYYY", true);
	return birthDate.isValid() && birthDate.isBefore(new Date());
};

/**
 * Luhn algorithm in JavaScript: validate credit card number supplied as string of numbers
 * @author ShirtlessKirk. Copyright (c) 2012.
 * @license WTFPL (http://www.wtfpl.net/txt/copying)
 */
export const luhnAlgorithm = (function(arr) {
	return function(ccNum) {
		let len = ccNum.length,
			bit = 1,
			sum = 0,
			val;

		while (len) {
			val = parseInt(ccNum.charAt(--len), 10);
			sum += (bit ^= 1) ? arr[val] : val;
		}

		return sum && sum % 10 === 0;
	};
})([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);
